import CryptoJS from "crypto-js";

const SECRET_KEY = "7Fv9Lm2Qx8WpNc4Hs1KdZe6Ry3TuBj5A"; // must match server's key
const INIT_VECTOR = "Q8mR2xLp9Vz7Ht4N";                 // must match server's IV

export function encryptAES(data) {
  const text = JSON.stringify(data);
  const key = CryptoJS.enc.Utf8.parse(SECRET_KEY);
  const iv = CryptoJS.enc.Utf8.parse(INIT_VECTOR);

  const encrypted = CryptoJS.AES.encrypt(text, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encrypted.toString();
}